import { FC } from "react";
import { Box } from "@chakra-ui/react";

import { CaseDocumentFileModel } from "@shared/models";
import { FONT_WEIGHT } from "@assets/theme/foundations/textStyle";

import { getFileTypeLabel } from "./CaseDocuments.utils";

interface CaseDocumentFileTagProps {
  file: Pick<CaseDocumentFileModel, "mime_type">;
  /** Greys the tag out, for a file that couldn't be read */
  muted?: boolean;
}

const getTagColor = (label: string, muted?: boolean) => {
  if (muted) return "grey.10";

  return label === "PDF" ? "brand.red" : "blue.700";
};

const CaseDocumentFileTag: FC<CaseDocumentFileTagProps> = ({ file, muted }) => {
  const label = getFileTypeLabel(file);

  return (
    <Box
      as="span"
      flexShrink={0}
      minW="34px"
      px="5px"
      py="3px"
      borderRadius="3px"
      bg={getTagColor(label, muted)}
      color="brand.white"
      fontSize="10px"
      fontWeight={FONT_WEIGHT.BOLD}
      lineHeight={1}
      textAlign="center"
    >
      {label}
    </Box>
  );
};

export default CaseDocumentFileTag;
